<template>
  <div v-html="dataInfo"></div>
</template>

<script>
  export default {
    name: 'GetInfoHeader',
    data () {
      return {
        dataInfo: null
      }
    },
    created () {
      axios.get("http://quatangamnhac.vn/getheader.php")
        .then(response => {
          this.dataInfo = response.data;
        })
      .catch(error => {
        console.log(error);
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GetInfoHeader.vue